import React from 'react';

import { getGmailOAuthUrl } from '../services/gmailService';

export default function ConnectGmailButton() {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const onConnect = async () => {
    try {
      setError(null);
      setLoading(true);
      const url = await getGmailOAuthUrl();
      window.location.assign(url);
    } catch (e: any) {
      const message = e?.response?.data?.message || e?.message || 'Failed to start Gmail connection';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <button
        onClick={onConnect}
        disabled={loading}
        className="px-4 py-2 rounded bg-blue-600 text-white disabled:opacity-60"
      >
        {loading ? 'Connecting…' : 'Connect Gmail'}
      </button>
      {error && <div className="text-sm text-red-600">{error}</div>}
    </div>
  );
}
